module.exports = __webpack_public_path__ + "static/media/box6-inset.b59c3035.png";